/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 身份验证、PC端更换手机号码(成功后返回唯一标识)
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  verifyDTO: member.VerifyDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/verify`,
    data: verifyDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
